// extracted by mini-css-extract-plugin
export default {"comingsoon":"comingsoon_comingsoon__W7+KJ","heading":"comingsoon_heading__4rs7T","text":"comingsoon_text__oyD02"};